export enum GiroEmpresa {
    AguaPotable,
    BienesRaices,
    Cinematrografia,
    Cobranza,
    Comercial,
    Construccion,
    Derecho,
    DeServicio,
    Editorial,
    Electricidad,
    EmpresaDiseño,
    Industrial,
    Ganaderia,
    Metalurgia,
    MercadoMayorista,
    Mineria,
    Pesca,
    ProductoresAgricolas,
    Software,
    Transporte,
    Telecomunicaciones,
    Turismo,
    Vigilancia
}

export enum Clasificacion {
    A,
    AA,
    AAA
}

/**Datos comercial de un cliente. Estos campos son utilizados para los reportes de estadísticas de cliente*/
export interface DatosComercial  {
    /*Valor que indica el potencial de guías enviadas por mes de este cliente*/
    PotencialEnvioPkts: number;
    
    /*Valor que indica el potencial de guías recibidas por mes de este cliente*/
    PotencialRecepcionPkts: number;

    /*Valor que indica el potencial de dinero de guías enviadas por mes de este cliente*/
    PotencialEnvioDinero: number;
        
    /*Valor que indica el potencial de dinero de guías recibidas por mes de este cliente*/
    PotencialRecepcionDinero: number;

    /** Giro de la empresa */
    GiroEmpresa: GiroEmpresa | null;

    /** Clasificación de la empresa */
    Clasificacion: Clasificacion | null;

}

export enum c_ParteTransporte {
    PT01_Camión_unitario,
    PT02_Camión,
    PT03_Tractocamión,
    PT04_Remolque,
    PT05_Semirremolque,
    PT06_Vehículo_ligero_de_carga,
    PT07_Grúa,
    PT08_Aeronave,
    PT09_Barco_o_buque,
    PT10_Carro_o_vagón,
    PT11_Contenedor,
    PT12_Locomotora
}


// WEBPACK FOOTER //
// ./app/models/datoscomercial.ts